export default __webpack_public_path__ + "vsdc.2cdefa49.png";